import React from "react";
import { FormControlLabel as MuiFormControlLabel } from "@mui/material";

export const FormControlLabel = ({ value, control, label, className }) => (
  <MuiFormControlLabel {...{ value, control, label, className }} />
);
